import { get, isNil } from 'lodash'
import { transformDepValue } from './utils'

export function whenBuilder(dep) {
  let trueVal = null
  let falseVal = null
  const instance = {
    truthy(val) {
      trueVal = val
      return instance
    },
    falsy(val) {
      falseVal = val
      return instance
    },
    toCss(props) {
      const depValue = props[dep]
      let css = {}
      if (depValue) {
        css = trueVal
      } else {
        css = falseVal
      }
      return css
    },
  }
  return instance
}

export function switchBuild(dep) {
  const values = {}
  let defaultBs = null

  const instance = {
    case(variant, bs) {
      values[variant] = bs
      return instance
    },
    default(bs) {
      defaultBs = bs
      return instance
    },
    toCss(props) {
      const depValue = props[dep]
      const css = get(values, depValue, defaultBs)
      return css
    },
  }
  return instance
}

export function varBuilder(dep, bsTemplate, fallback) {
  const instance = {
    mergeWithOverride: () => ({}),
    toCss(props) {
      let depValue = props[dep]
      if (isNil(depValue)) {
        depValue = fallback
      }
      const bs = transformDepValue(
        bsTemplate,
        val => val.replace('_VAR_', depValue),
      )
      return bs
    },
  }
  return instance
}
